// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__OgIqC","sm":"Icon_sm__evuV9","md":"Icon_md__MvKfQ","lg":"Icon_lg__OX1rz","xl":"Icon_xl__nnaB9"};